































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';

import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import { UnitSystem } from '@/interfaces/units';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import { findZr } from '@/modules/design/lib/calculations/calculationUtils';
import { weatherData } from '@/lib/data/weatherData';
import { DEGF_TO_DEGC, INCHES_TO_CM, MPH_TO_KPH } from '@/lib/unitConversion/unitConversionFactors';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import { designStore } from '@/store/store';
import { Route } from 'vue-router';
import { states } from '@/lib/data/states';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';
import { createConcreteValidations } from '@/modules/design/lib/validations/concrete';

@Component({
  components: {
    ValidatedInputPageWrapper,
    PxTextEntryBox,
    PxDropdown,
    PxNumberInput,
    InputPageWrapper,
  },
})
export default class NewConcreteDesignParameters extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentConcrete;
  }

  get scenarioImperial() {
    return designStore.currentConcreteImperial;
  }

  validations() {
    return createConcreteValidations(this.scenarioImperial);
  }

  sync() {
    designStore.setCurrentConcreteScenario(this.scenario);
  }

  save() {
    this.sync();
    designStore.saveCurrentConcreteScenario();
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next();
  }

  weatherData = weatherData;

  reliabilityOptions: { value: number, text: string }[] = [
    { value: 50, text: '50%' },
    { value: 60, text: '60%' },
    { value: 70, text: '70%' },
    { value: 75, text: '75%' },
    { value: 80, text: '80%' },
    { value: 85, text: '85%' },
    { value: 90, text: '90%' },
    { value: 95, text: '95%' },
    { value: 99, text: '99%' },

  ];

  get isImperial() {
    const v = this.scenario.unitSystem === UnitSystem.Imperial;
    return v;
  }

  get weatherState() {
    return states.filter((S) => S.value === this.scenario.state)[0].text;
  }

  get cityOptions() {
    if (this.scenario.state === null) {
      return null;
    }
    const r = weatherData[this.weatherState].map((k) => k);
    return r.map((c) => ({ value: c.value, text: c.label }));
  }

  setWeatherData() {
    if (this.scenario.state) {
      const wd = weatherData[this.weatherState].filter((x) => x.label === this.scenario.nearestCity)[0];
      if (this.scenario.unitSystem === UnitSystem.Imperial) {
        this.scenario.meanWindSpeed_mph = Number(wd.wind);
        this.scenario.meanPrecip_in = Number(wd.precip);
        this.scenario.meanTemp_degF = Number(wd.temp);
      } else if (this.scenario.unitSystem === UnitSystem.Metric) {
        this.scenario.meanWindSpeed_kph = Number(wd.wind) * MPH_TO_KPH;
        this.scenario.meanPrecip_cm = Number(wd.precip) * INCHES_TO_CM;
        this.scenario.meanTemp_degC = DEGF_TO_DEGC(Number(wd.temp));
      }
    }
    this.sync();
    return null;
  }

  get zr() {
    const zr = findZr(this.scenario.reliabilityLevel || 50);
    return zr;
  }

  get deltaServiceability(): number | null {
    if (this.scenario.terminalServiceability !== null && this.scenario.initialServiceability !== null) {
      this.scenario.deltaServiceability = this.scenario.initialServiceability - this.scenario.terminalServiceability;
      // return Math.abs(this.scenario.deltaServiceability)
      return this.scenario.deltaServiceability;
    }
    return null;
  }
}
